import GLightbox from 'glightbox';

class LoadMorePosts {
    constructor() {
        const _self = this;

        this.triggers = document.querySelectorAll('.js-load-more-posts');

        var page = 1;

        _self.triggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                event.preventDefault();

                page++;

                let action;

                action = 'boilerpress_load_more_posts';

                $.ajax({
                    data: {
                        action: action,
                        page: page,
                        query: boilerpress_load_more_posts_variables.posts,
                    },
                    type: 'POST',
                    url: '/wp-admin/admin-ajax.php',
                    success: function (data) {
                        if (data) {
                            $('#load-more-posts').append(data);

                            const loadMorePostsEvent = new Event(
                                'load-more-posts-complete'
                            );

                            window.dispatchEvent(loadMorePostsEvent);

                            GLightbox({
                                selector: '.glightbox-portrait',
                                autoplayVideos: true,
                                loop: true,
                                touchNavigation: true,
                                plyr: {
                                    config: {
                                        ratio: '9:16',
                                    },
                                },
                            });
                        }
                    },
                });
            });
        });
    }
}

export default LoadMorePosts;
